import { lazy, Suspense, ComponentType } from 'react';
import { RouteObject } from 'react-router-dom';

// Regular lazy‑loaded pages
const Home = lazy(() => import('../pages/home/page'));
const Category = lazy(() => import('../pages/category/page'));
const Article = lazy(() => import('../pages/article/page'));
const ArticleEscritorioContabil = lazy(() => import('../pages/article-escritorio-contabil/page'));
const ArticleContadorIA = lazy(() => import('../pages/article-contador-ia/page'));
const ArticleFolhaPagamento = lazy(() => import('../pages/article-folha-pagamento/page'));
const ArticleReformaTributariaEsocial = lazy(() => import('../pages/article-reforma-esocial/page'));
const ArticleEsocial2026 = lazy(() => import('../pages/article-esocial-2026/page'));
const ArticlePlanejamentoTributario = lazy(() => import('../pages/article-planejamento-tributario/page'));
const ArticleAutomacaoContabil = lazy(() => import('../pages/article-automacao-contabil/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const ArticleGestaoAtivosFixos = lazy(() => import('../pages/article-gestao-ativos-fixos/page'));
const ArticleTestesRH = lazy(() => import('../pages/article-testes-rh/page'));
const ArticleReformaLucroPresumidoReal = lazy(() => import('../pages/article-reforma-lucro-presumido-real/page'));
const ArticleFimCiapPisCofins = lazy(() => import('../pages/article-fim-ciap-pis-cofins/page'));
const ArticleInventarioEstoques = lazy(() => import('../pages/article-inventario-estoques/page'));
const ArticleIVADual = lazy(() => import('../pages/article-iva-dual/page'));
const ArticleCIAPReformaTributaria = lazy(() => import('../pages/article-ciap-reforma-tributaria/page'));

// Pages that were previously loaded with the `lazy` property of RouteObject.
// They are now imported lazily using React.lazy and rendered via a wrapper
// component that provides a fallback UI and basic error handling.
const CategoryReformaTributaria = lazy(() =>
  import('../pages/category-reforma-tributaria/page')
);
const ArticleTemplate = lazy(() => import('../pages/article-template/page'));
const ArticleReformaTributariaConsumo = lazy(() =>
  import('../pages/article-reforma-tributaria-consumo/page')
);
const ArtigoFatoGeradorReforma = lazy(() => import('../pages/article-fato-gerador-reforma/page'));

// Helper component to wrap lazy components with Suspense and a simple error boundary.
function withSuspense(
  Component: React.LazyExoticComponent<React.ComponentType<any>>
) {
  return (
    <Suspense fallback={<div>Carregando…</div>}>
      <Component />
    </Suspense>
  );
}

const routes: RouteObject[] = [
  {
    path: '/',
    element: withSuspense(Home),
  },
  {
    path: '/categoria/:slug',
    element: withSuspense(Category),
  },
  {
    // Previously used the `lazy` field – now handled with a lazy component.
    path: '/categoria/reforma-tributaria',
    element: withSuspense(CategoryReformaTributaria),
  },
  {
    path: '/artigo/:slug',
    element: withSuspense(Article),
  },
  {
    path: '/artigo/planejamento-tributario',
    element: withSuspense(ArticlePlanejamentoTributario),
  },
  {
    path: '/artigo/como-administrar-escritorio-contabil-sucesso',
    element: withSuspense(ArticleEscritorioContabil),
  },
  {
    path: '/artigo/papel-contador-era-inteligencia-artificial',
    element: withSuspense(ArticleContadorIA),
  },
  {
    path: '/artigo/gestao-folha-pagamento-guia-completo',
    element: withSuspense(ArticleFolhaPagamento),
  },
  {
    path: '/artigo/reforma-tributaria-esocial-guia-completo',
    element: withSuspense(ArticleReformaTributariaEsocial),
  },
  {
    path: '/artigo/esocial-guia-completo-empresas-2026',
    element: withSuspense(ArticleEsocial2026),
  },
  {
    path: '/artigo/automacao-contabil-ferramentas-essenciais',
    element: withSuspense(ArticleAutomacaoContabil),
  },
  {
    path: '/artigo/gestao-ativos-fixos-controle-patrimonial',
    element: withSuspense(ArticleGestaoAtivosFixos),
  },
  {
    path: '/artigo/testes-recursos-humanos-contratacao',
    element: withSuspense(ArticleTestesRH),
  },
  {
    path: '/artigo/reforma-tributaria-lucro-presumido-real',
    element: withSuspense(ArticleReformaLucroPresumidoReal),
  },
  {
    path: '/artigo/fim-ciap-pis-cofins-reforma-tributaria',
    element: withSuspense(ArticleFimCiapPisCofins),
  },
  {
    path: '/artigo/inventario-estoques-ajustes-perdas',
    element: withSuspense(ArticleInventarioEstoques),
  },
  {
    path: '/artigo/iva-dual-ibs-cbs',
    element: withSuspense(ArticleIVADual),
  },
  {
    path: '/artigo/ciap-reforma-tributaria',
    element: withSuspense(ArticleCIAPReformaTributaria),
  },
  {
    path: '/artigo/gestao-integrada-ativos-fixos',
    element: withSuspense(ArticleTemplate),
  },
  {
    path: '/artigo/reforma-tributaria-consumo',
    element: withSuspense(ArticleReformaTributariaConsumo),
  },
  {
    path: '/artigo/fato-gerador-reforma-tributaria',
    element: withSuspense(ArtigoFatoGeradorReforma),
  },
  {
    path: '/contato',
    element: withSuspense(Contact),
  },
  {
    path: '*',
    element: withSuspense(NotFound),
  },
];

export default routes;
